import { useCallback } from 'react';
import { useRequest } from '@Hooks';
import { API } from '@Services';
import { ApiErrorObject } from '@Types';

export const useResetPassword = () => {
  const [fetch, response] = useRequest<ApiErrorObject | { detail: 'ok' }>();

  const resetPassword = useCallback(
    (email: string) =>
      fetch(API.paths.password_reset, 'post', {
        data: { email },
      }),
    [fetch],
  );

  return [resetPassword, response] as const;
};
